import http from '@/http'

export function user(params, loading = true) {
  return http.get('/cex/order/user', {
    loading,
    params
  })
}

export function ok(id) {
  return http.get('/cex/order/ok/' + id)
}

export function no(id) {
  return http.get('/cex/order/no/' + id)
}